<template>
    <div class="registerscreen">
        <div class="container-fluid" style="background: #f2f2f2;">
            <div class="containers">
                <div class="row header-login">
                    <div class="col-lg-3 col-md-2 col-sm-1 mobilescreencol">

                    </div>
                    <div class="col-lg-6 col-sm-10 col-md-8 col-xs-12"
                        style="background: #FFFFFF; border-radius: 15px;">
                        <form>
                            <h2 class="text-center acount-header">{{ $t('message.registerAccount') }}</h2>
                            <p class="login-paragraph text-center">{{ $t('message.pleaseEnterYourCredentialToRegister')
                                }}
                            </p>
                            
                            <!-- Username field -->
                            <div class="mb-6 mt-2 emailmargin">
                                <div class="row">
                                    <div class="col-12">
                                        <label class="inner-block">{{ $t('message.username') }}<span
                                                style="color: #FF0000;padding-right: 6px"> *</span></label>
                                        <input type="text" v-model="names"
                                            :class="{ 'is-invalid': is_register && $v.names.$error }"
                                            class="form-control form-control-lg form-input-login"
                                            :placeholder="$t('message.username')" />
                                        <div v-if="is_register && !$v.names.required" class="invalid-feedback">
                                            {{ $t('message.yourFullNameRequired') }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Nationality and Gender fields -->
                            <div class="mt-4 emailmargin">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-2">
                                        <label class="inner-block">{{ $t('message.nationality') }}<span
                                                style="color: #FF0000;padding-right: 6px"> *</span></label>
                                        <div class="equals_input" style="position: relative;">
                                            <i @click="selectNation()"
                                                class="fa-sharp fa-solid fa-caret-down absoluteicon"></i>
                                            <input @click="selectNation()" @input="filterNations" type="text"
                                                v-model="nationality"
                                                :class="{ 'is-invalid': is_register && $v.nationality.$error }"
                                                class="form-control form-control-lg form-input-login1"
                                                :placeholder="$t('message.selectNationality')" />
                                        </div>
                                        <div v-if="is_register && !$v.nationality.required" class="invalid-feedback">
                                            {{ $t('message.yourNationalityRequired') }}</div>
                                        <div class="absolutedropdownnational" v-if="showListDataNation"
                                            v-click-outside="hidePopupNation">
                                            <div style="margin-top: 10px;cursor: pointer;padding-left: 12px;padding-top: 5px;padding-bottom: 5px;"
                                                class="hover-color" v-for="(nation, i) in filteredNations" :key="i"
                                                @click="setNational(nation.id, nation.name)">{{ nation.name }}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-2">
                                        <label class="inner-block">{{ $t('message.gender') }}<span
                                                style="color: #FF0000; padding-right: 6px"> *</span></label>
                                        <div class="equals_input" style="position: relative;">
                                            <i @click="selectGender()"
                                                class="fa-sharp fa-solid fa-caret-down absoluteicon"></i>
                                            <input type="text" readonly v-model="selectedOptionGender"
                                                :class="{ 'is-invalid': is_register && $v.selectedOptionGender.$error }"
                                                class="form-control form-control-lg form-input-login1"
                                                :placeholder="$t('message.gender')" @click="selectGender()" />
                                        </div>
                                        <div v-if="is_register && !$v.selectedOptionGender.required"
                                            class="invalid-feedback">{{ $t('message.yourGenderRequired') }}</div>
                                        <div class="absolutedropdown" v-if="showListDataGen"
                                            v-click-outside="hidePopupGen">
                                            <div style="margin-top: 10px;cursor: pointer;padding-left: 12px;padding-top: 5px;padding-bottom: 5px;"
                                                class="hover-color" @click="setGender(1)">Male</div>
                                            <div style="margin-top: 10px;margin-bottom: 10px;cursor: pointer;padding-left: 12px;padding-top: 5px;padding-bottom: 5px;"
                                                class="hover-color" @click="setGender(2)">Female</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Email field -->
                            <div class="mb-4 mt-2 emailmargin">
                                <div class="row">
                                    <div class="col-12">
                                        <label class="inner-block">{{ $t('message.email') }}<span
                                                style="color: #FF0000;padding-right: 6px"> *</span></label>
                                        <input type="email" v-model="email"
                                            :class="{ 'is-invalid': is_register && $v.email.$error }"
                                            class="form-control form-control-lg form-input-login"
                                            :placeholder="$t('message.email')" />
                                        <div v-if="is_register && !$v.email.required" class="invalid-feedback">
                                            {{ $t('message.yourEmailRequire') }}</div>
                                        <div v-if="msg.email" style="color: #FF0000;">{{ msg.email }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Telephone field -->
                            <div class="mb-4 mt-2 emailmargin">
                                <div class="row">
                                    <div class="col-12">
                                        <label class="inner-block">{{ $t('message.enterTelephoneNumber') }}<span
                                                style="color: #FF0000;"></span></label>
                                        <div class="number-phone-box"
                                            style="display: flex; align-items: center; width: 97%; border-radius: 6px; border: 1px solid #C6C6C6;">
                                            <div
                                                style="width: 13%; height: 36px; display: flex; justify-content: center; align-items: center; border-right: 1px solid #C6C6C6;">
                                                +855
                                            </div>
                                            <div style="width: 82%;">
                                                <input type="tel" v-model="telephoneNumber" @input="validatePhoneNumber"
                                                    class="form-control form-control-lg form-input-login form-password"
                                                    :placeholder="$t('message.telephoneNumber')" />
                                            </div>
                                        </div>
                                        <span v-if="phoneNumberError.phone" style="color: #FF0000;">{{ phoneNumberError.phone
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Password field -->
                            <div class="mb-7 mt-2 emailmargin" style="position: relative;">
                                <div class="row">
                                    <div class="col-12">
                                        <label class="inner-block">{{ $t('message.enterPassword') }} <span
                                                style="color: #FF0000; padding-right: 6px"> *</span></label>
                                        <input v-if="showPassword" :class="{ 'is-invalid': is_register && $v.password.$error }"
                                            type="text" v-model="password" class="form-control form-control-lg form-input-login"
                                            :placeholder="$t('message.enterPassword')" />
                                        <input type="password" :class="{ 'is-invalid': is_register && $v.password.$error }"
                                            autocomplete="off" v-else class="form-control form-control-lg form-input-login"
                                            :placeholder="$t('message.enterPassword1')" v-model="password" />
                                        <button type="button" class="button" @click="toggleShowPassword"><span
                                                class="icon is-small is-right">
                                                <i class="fas"
                                                    :class="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"></i>
                                            </span>
                                        </button>
                                        <div v-if="is_register && !$v.password.required" class="invalid-feedback">
                                            {{ $t('message.yourPasswordRequired') }}</div>
                                        <div v-if="!$v.password.minLength" class="invalid-feedback">
                                            {{ $t('message.yourPasswordHaveDigit') }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Register button -->
                            <div class="mb-7 mt-2 emailmargin">
                                <div class="row">
                                    <div class="col-12">
                                        <v-btn :disabled="disabled" style="border-radius: 4px; width:  97%; outline: none;"
                                            @click="addRegisterUser()" color="#DE5D0A" height="50px"
                                            class="text-capitalize btn-width reposo-height">
                                            <span style="color: #FFF; font-size: 20px !important;"> {{ $t(titleRegister) }}
                                            </span>
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-3 col-md-2 col-sm-1 mobilescreencol">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    required,
    email,
    minLength,
} from "vuelidate/lib/validators";
import axios from 'axios';
// import { data } from "jquery";
export default {
    data() {

        return {
            index: 0,
            showListDataGen: false,
            showListDataNation: false,

            maxLength: 8, // maximum allowed phone number length
            maxLengths: 10, // maximum allowed phone number length
            phoneNumberError: [],
            showPassword: false,
            msg: [],
            listnation: [],
            filteredNations: [],
            password: '',
            names: '',
            nationality: '',
            nationalityid: '',
            selectedOptionGenderid: '',
            selectedOptionGender: '',
            email: '',
            telephoneNumber: '',
            titleRegister: 'message.register',
            disabled: false,
            is_register: false,
        }
    },
    validations: {
        names: { required },
        password: { required, minLength: minLength(4) },
        nationality: { required },
        selectedOptionGender: { required },
        email: { required, email },

    },
    watch: {
        email(value) {
            // binding this to the data value in the email input
            this.email = value;
            this.validateEmail(value);
        },
        telephoneNumber(value) {
            this.telephoneNumber = value;
            this.validatePhoneNumber(value);
        },
    },
    methods: {
        toggleShowPassword() {
            this.showPassword = !this.showPassword;
        },
        setGender(value) {
            this.index = value;
            // localStorage.setItem('gender',  this.index);
            if (this.index == 0) {
                this.selectedOptionGender = "Gender";
                this.selectedOptionGenderid = 0;
            } else if (this.index == 1) {
                this.selectedOptionGender = "Male";
                this.selectedOptionGenderid = 1;
            } else {
                this.selectedOptionGender = "Female";
                this.selectedOptionGenderid = 2;
            }

            this.showListDataGen = false;
        },
        selectGender() {
            this.showListDataGen = true;
        },
        hidePopupGen() {
            this.showListDataGen = false;
        },
        //nationality
        selectNation() {
            this.getNationality();
            this.showListDataNation = true;
            this.filteredNations = [...this.listnation];
        },
        hidePopupNation() {
            this.showListDataNation = false;
        },
        setNational(id, name) {
            // this.index = value;
            // localStorage.setItem('nationalityId',  this.index);
            // if(this.index == 0) {
            //     this.nationality = "Nationality";
            //     this.nationalityid = 0;
            // }else if(this.index == 1){
            //     this.nationality = "Cambodian";
            //     this.nationalityid = 1;
            // }else{
            //     this.nationality = "Non-Cambodian";
            //     this.nationalityid = 2;
            // }
            this.nationality = name;
            this.nationalityid = id;

            this.showListDataNation = false;
        },

        async getNationality() {
            const url = this.$url + `travel-package/nationalityList`;

            let config = {
                method: "POST",
                headers: this.$header,
                url,
            };

            axios(config).then((response) => {
                if (response.status == 200) {

                    if (response.data.header.result == true && response.data.header.statusCode == 200) {
                        if (response.data.body.status == true || response.data.body.message == 'Success') {
                            this.listnation = response.data.body.data;
                        } else {
                            alert(response.data.body.message)
                        }

                    }
                }
            }).catch((error) => {
                console.log(error);
            });
        },

        async addRegisterUser() {
            this.is_register = true,
                this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.titleRegister = 'Loading';
                this.disabled = true;
                localStorage.setItem('emailUser',  this.email);

                // Prepend '0' if the telephoneNumber doesn't start with it
                let formattedPhoneNumber = this.telephoneNumber;
                if (this.telephoneNumber && !this.telephoneNumber.startsWith('0')) {
                    formattedPhoneNumber = this.telephoneNumber;
                }

                const data = {
                    'firstName': this.names,
                    'nationalityId': parseInt(this.nationalityid),
                    'gender': parseInt(this.selectedOptionGenderid),
                    'email': this.email,
                    // 'telephone'      : this.telephoneNumber,
                    'password': this.password,
                };
                // Add telephone if it exists
                // if (this.telephoneNumber) {
                // data.telephone = this.telephoneNumber;
                // }
                if (formattedPhoneNumber) {
                    data.telephone = formattedPhoneNumber;
                }
                const url = this.$url + `user-register/register`;
                let config = {
                    method: "POST",
                    headers: {
                        ...this.$header,
                        "Content-Type": "multipart/form-data"
                    },
                    data: data,
                    url,
                };
                axios(config).then((response) => {
                    if (response.status == 200) {
                        this.titleRegister = 'message.register';
                        this.disabled = false;
                        if (response.data.header.result == true && response.data.header.statusCode == 200) {
                            if (response.data.body.status == true) {
                                let token = response.data.body.message;
                                localStorage.setItem('tokenUser', token);
                                this.$router.push("/comfirm-otp");
                            } else {
                                let message = response.data.body.message;
                                if (message.includes("Duplicate email or telephone")) {
                                    message = "Your account already exists";
                                }
                                alert(message);

                            }
                        } else {
                            alert("Please Input Information");
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });

            }
        },
        validatePhoneNumber(value) {
            const regex = /^[+]?\d{1,3}[-.\s]?\d{1,14}$/; // regular expression to validate phone number
            if (regex.test(value)) {
                if (value.length < this.maxLength) {
                    this.phoneNumberError['phone'] = 'Telephone number is invalid';
                } else if (value.length <= this.maxLengths || this.telephoneNumber.length == this.maxLength) {
                    this.phoneNumberError['phone'] = ''; // valid phone number within length limit
                } else {
                    this.phoneNumberError['phone'] = 'Telephone number is invalid'; // invalid phone number exceeding length limit
                }
            } else {
                this.phoneNumberError['phone'] = 'Telephone number is invalid'; // invalid phone number
            }
        },
        validateEmail(value) {
            if (/^[\w+.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                this.msg['email'] = '';
            } else {
                this.msg['email'] = 'Email is invalid';
            }
        },
        handleKeydown(event) {
            if (event.key === 'Enter') {
                this.addRegisterUser();
            }
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        filterNations() {
            if (!this.nationality) {
                this.filteredNations = [...this.listnation];
            } else {
                const searchTerm = this.nationality.toLowerCase();
                this.filteredNations = this.listnation.filter(nation =>
                    nation.name.toLowerCase().includes(searchTerm)
                );
            }
            this.showListDataNation = true;
        },

    },
    mounted() {
        document.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeydown);
    },
    created() {
        // localStorage.setItem("handleBrowser", 1);
        localStorage.setItem('handleRemamberPage', 1); //1 register user 2 forgot page            
        this.scrollToTop();
        this.getNationality();
    }
}
</script>
<style scoped>
.registerscreen {
    padding-top: 55px;
    margin-top: 28px;
    background: #f2f2f2;
    min-height: 100vh;
}

.container-fluid {
    background: #f2f2f2 !important;
}

.containers {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
}

.header-login {
    padding-top: 50px;
    padding-bottom: 70px;
}

/* Form container styling */
.col-lg-6.col-sm-10.col-md-8.col-xs-12 {
    background: #FFFFFF !important;
    border-radius: 15px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 40px 30px;
    margin: 0 auto;
}

/* Header styling */
.acount-header {
    margin-top: 0;
    margin-bottom: 10px;
    color: #1a365d;
    font-size: 28px;
    font-weight: 600;
}

.login-paragraph {
    color: #6A6969;
    font-size: 14px;
    margin-bottom: 30px;
}

/* Form field styling */
.emailmargin {
    margin-bottom: 25px;
}

.inner-block {
    display: block;
    width: 100%;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333;
    font-size: 14px;
}

/* Input field styling */
.form-input-login,
.form-input-login1 {
    width: 100% !important;
    border: 1px solid #C6C6C6;
    border-radius: 8px;
    height: 48px;
    outline: none;
    padding: 12px 16px;
    font-size: 14px;
    transition: border-color 0.3s ease;
}

.form-input-login:focus,
.form-input-login1:focus {
    border-color: #DE5D0A;
    box-shadow: 0 0 0 3px rgba(222, 93, 10, 0.1);
}

/* Nationality and Gender row */
.mt-4.emailmargin .row {
    margin: 0 -10px;
}

.mt-4.emailmargin .col-lg-6 {
    padding: 0 10px;
}

/* Containing block for absolute dropdowns */
.mt-4.emailmargin .col-lg-6.col-md-6.col-sm-6.col-xs-12 {
    position: relative;
}

/* Dropdown styling */
.equals_input {
    position: relative;
}

.absoluteicon {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    color: #666;
    cursor: pointer;
    z-index: 2;
}

/* Dropdown menus */
.absolutedropdown,
.absolutedropdownnational {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    background: #fff;
    z-index: 1000;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.absolutedropdownnational {
    max-height: 250px;
}

.hover-color {
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    border-bottom: 1px solid #f1f5f9;
}

.hover-color:last-child {
    border-bottom: none;
}

.hover-color:hover {
    background: #DE5D0A;
    color: #ffffff;
}

/* Phone number field styling */
.number-phone-box {
    display: flex;
    align-items: center;
    width: 100% !important;
    border-radius: 8px;
    border: 1px solid #C6C6C6;
    overflow: hidden;
    transition: border-color 0.3s ease;
}

.number-phone-box:focus-within {
    border-color: #DE5D0A;
    box-shadow: 0 0 0 3px rgba(222, 93, 10, 0.1);
}

.number-phone-box > div:first-child {
    width: 80px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f8f9fa;
    border-right: 1px solid #C6C6C6;
    color: #666;
    font-weight: 500;
    font-size: 14px;
}

.number-phone-box > div:last-child {
    flex: 1;
}

.number-phone-box input {
    border: none !important;
    border-radius: 0 !important;
    height: 48px;
    padding: 12px 16px;
    width: 100%;
}

/* Password field styling */
.mb-7.mt-2.emailmargin {
    position: relative;
}

.button {
    position: absolute;
    right: 16px;
    bottom: 1px;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    transition: color 0.2s ease;
}

.button:hover {
    color: #DE5D0A;
}

/* Register button styling */
.v-btn {
    width: 100% !important;
    border-radius: 8px !important;
    background: #DE5D0A !important;
    height: 52px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    text-transform: none !important;
    box-shadow: 0 4px 15px rgba(222, 93, 10, 0.3);
    transition: all 0.3s ease;
}

.v-btn:hover {
    background: #c54a08 !important;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(222, 93, 10, 0.4);
}

.v-btn:disabled {
    background: #ccc !important;
    transform: none;
    box-shadow: none;
}

/* Validation styling */
.invalid-feedback {
    color: #FF0000;
    font-size: 12px;
    margin-top: 5px;
    display: block;
}

.is-invalid {
    border: 1px solid #FF0000 !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .col-lg-6.col-sm-10.col-md-8.col-xs-12 {
        padding: 30px 20px;
        margin: 0 15px;
    }
    
    .acount-header {
        font-size: 24px;
    }
    
    .form-input-login,
    .form-input-login1,
    .number-phone-box {
        height: 44px;
    }
    
    .v-btn {
        height: 48px !important;
    }
}

@media (max-width: 480px) {
    .col-lg-6.col-sm-10.col-md-8.col-xs-12 {
        padding: 25px 15px;
        margin: 0 10px;
    }
    
    .header-login {
        padding-top: 30px;
        padding-bottom: 50px;
    }
    
    .acount-header {
        font-size: 22px;
    }
    
    .emailmargin {
        margin-bottom: 20px;
    }
}

/* Remove old media queries that are no longer needed */
</style>